<template>
    <div width="100%">
        <h4><b>{{ $t('faq.title') }}</b></h4>
        <el-table :show-header="false" :data="faqs" style="width:100%" :row-key="getRowKeys" :expand-row-keys="expands" @row-click="rowClick">
                <el-table-column type='expand' width='60px'>
                    <template scope="props">
                        <p v-for="(item,index) in props.row.answer" :key="index" v-html="item"></p>
                    </template>
                </el-table-column>
                <el-table-column type="index">
                </el-table-column>
                <el-table-column  width='740px'>
                    <template slot-scope="scope">
                        <i :class="scope.row.icon"></i>
                        <span style="margin-left: 10px">{{ scope.row.question }}</span>
                    </template>
                </el-table-column>
        </el-table>
        <div style="margin-top:40px">
            <!-- <a href="https://www.searchplusplus.jp/Query.html">問い合わせフォーム</a> -->
            <el-button type="success" @click="$router.push('query')">{{ $t('faq.queryButton') }}</el-button>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      expands: []
    }
  },
  computed: {
    faqs () {
      return this.$t('faq.items')
    }
  },
  methods: {
    getRowKeys (row) {
      return row.id
    },
    rowClick (row) {
      if (row.id === this.expands[0]) { // collapsed
        this.expands = []
      } else { // expand
        this.expands = []
        this.expands.push(row.id)
      }
    }
  }
}

</script>

<style scoped>
.el-table__header {
  width: 100% !important;
  /* width: 850px; */
}

.el-table__body {
  width: 100% !important;
  /* width: 850px; */
}
</style>
